import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";

import CountDown from "../../CountDown";
import Link from "../../Link";

import { sendMessageAction } from "../../../actions/message/sendMessageAction";
import messages from "../../../locale/messages";
import { CommonClockIcon } from "../../Common/Assets/SvgComponent/commonSvgIcon";

import s from "../ViewMessage.css";
import bt from "../../../components/commonStyle.css";

const HostActions = ({
  actionType,
  threadId,
  reservationId,
  threadType,
  startDate,
  endDate,
  personCapacity,
  isCancelButtonShown,
  guestDisplayName,
  createdAt,
  listPublishStatus }) => {

  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.hostAction);
  const isAdminAuthenticated = useSelector((state) => state.runtime.isAdminAuthenticated);


  const sendMessage = async (type) => {
    dispatch(sendMessageAction(
      threadId,
      threadType,
      null,
      type,
      startDate,
      endDate,
      personCapacity,
      reservationId,
      null,
      null,
      null,
      null
    ));
  }

  // Inquiry
  const inquiry = () => {
    let startDate = moment();
    let next24Hours = moment(parseInt(createdAt)).add(23, "hours").add(59, "minutes");
    let distance = next24Hours - startDate;
    let options = { endDate: next24Hours };
    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        {distance > 0 ? (
          <div>
            <h4 className={s.contentBlockHeading}>
              <FormattedMessage {...messages.hostAction1} /> {guestDisplayName}{" "}
              <FormattedMessage {...messages.hostAction2} />
            </h4>
            <p className={cx(s.marginNone, s.contentSubText)}>
              <FormattedMessage {...messages.hostAction3} /> {guestDisplayName}{" "}
              <FormattedMessage {...messages.hostAction4} />
            </p>
            <p className={cx(s.spaceTop2, s.timerSection)}>
              <span>
                <CommonClockIcon classNam4={cx(s.textGray, s.timerIcon)} />
              </span>
              <span>
                <FormattedMessage {...messages.hostResponseTime1} />{" "}
                <CountDown options={options} />{" "}
                <FormattedMessage {...messages.hostResponseTime2} />
              </span>
            </p>

            <div className={s.contentSectionBtn}>
              <Button
                className={bt.btnPrimary}
                disabled={loading}
                onClick={() => sendMessage("preApproved")}
              >
                <FormattedMessage {...messages.preApprove} />
              </Button>
            </div>
          </div>
        ) : (
          <h4>
            <FormattedMessage {...messages.requestBookExpire} />
          </h4>
        )}
      </div>
    );
  }

  // Request to book
  const requestToBook = () => {
    let startDate = moment();
    let next24Hours = moment(parseInt(createdAt)).add(23, "hours").add(59, "minutes");
    let distance = next24Hours - startDate;
    let options = { endDate: next24Hours };

    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        {distance > 0 && (
          <div>
            <h4 className={s.contentBlockHeading}>
              {guestDisplayName} <FormattedMessage {...messages.guestRequest} />
            </h4>
            <p className={cx(s.marginNone, s.contentSubText)}>
              <FormattedMessage {...messages.hostAction3} /> {guestDisplayName}{" "}
              <FormattedMessage {...messages.hostAction4} />
            </p>
            <p className={cx(s.marginNone, s.contentSubText, s.spaceTop2)}>
              <FormattedMessage {...messages.hostResponseTime1} />{" "}
              <CountDown options={options} />{" "}
              <FormattedMessage {...messages.hostResponseTime2} />
            </p>
          </div>
        )}
        {distance > 0 && listPublishStatus && (
          <div className={s.contentSectionBtn}>
            <Button
              className={cx(bt.btnPrimary)}
              disabled={loading}
              onClick={() => sendMessage("approved")}
            >
              <FormattedMessage {...messages.approve} />
            </Button>
            <Button
              className={cx(bt.btnPrimaryBorder, s.btnRight, "requestBookBtn")}
              disabled={loading}
              onClick={() => sendMessage("declined")}
            >
              <FormattedMessage {...messages.decline} />
            </Button>
          </div>
        )}
        {distance < 0 && (
          <h4 className={s.contentBlockHeading}>
            {" "}
            <FormattedMessage {...messages.requestBookExpire} />
          </h4>
        )}
      </div>
    );
  }

  // Inquiry pre-approved
  const approved = () => {
    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        <h4 className={s.contentBlockHeading}>
          <FormattedMessage {...messages.requestApproved} />
        </h4>
        <p className={cx(s.marginNone, s.contentSubText)}>
          <FormattedMessage {...messages.timeToExpire} />
        </p>
      </div>
    );
  }

  // Request to book/ Inquiry declined
  const declined = () => {
    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        <h4 className={s.contentBlockHeading}>
          <FormattedMessage {...messages.requestDeclined} />
        </h4>
        <p className={cx(s.marginNone, s.contentSubText)}>
          <FormattedMessage {...messages.declinedInfo} />
        </p>
      </div>
    );
  }

  // Booking confirmed by host/ instant booking
  const bookingConfirmed = () => {
    if (!isCancelButtonShown) return <span></span>;
    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        <h4 className={s.contentBlockHeading}>
          <FormattedMessage {...messages.bookingIsConfirmed} />
        </h4>
        <p className={cx(s.marginNone, s.contentSubText)}>
          <FormattedMessage {...messages.contactGuest} />
        </p>
        <div className={s.contentSectionBtn}>
          {!isAdminAuthenticated && (
            <Link
              to={"/cancel/" + reservationId + "/host"}
              className={cx(s.linkBtn, bt.btnPrimary)}
            >
              <FormattedMessage {...messages.cancelTrip} />
            </Link>
          )}
        </div>
      </div>
    );
  }

  // Pre-approved or approved by host is expired
  const expired = () => {
    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        <h4 className={s.contentBlockHeading}>
          <FormattedMessage {...messages.bookingIsExpired} />
        </h4>
        <p className={cx(s.marginNone, s.contentSubText)}>
          {guestDisplayName}'s{" "}
          <FormattedMessage {...messages.bookingIsExpired1} />
        </p>
      </div>
    );
  }

  // Booking is cancelled by host
  const cancelled = () => {
    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        <h4 className={s.contentBlockHeading}>
          <FormattedMessage {...messages.bookingRequestCancel1} />
        </h4>
        <p className={cx(s.marginNone, s.contentSubText)}>
          {guestDisplayName}'s{" "}
          <FormattedMessage {...messages.bookingRequestCancel3} />
        </p>
      </div>
    );
  }

  const completed = () => {
    return (
      <div
        className={cx(
          s.spaceBottom15,
          s.contextPadding,
          s.infoContentBlock,
        )}
      >
        <h4 className={s.contentBlockHeading}>
          <FormattedMessage {...messages.reservationIsCompleted} />
        </h4>
        <p className={cx(s.marginNone, s.contentSubText)}>
          <FormattedMessage {...messages.reservationIsCompletedDescription} />
        </p>
      </div>
    );
  }

  if (actionType === "inquiry") {
    return inquiry();
  } else if (actionType === "preApproved") {
    return approved();
  } else if (actionType === "declined") {
    return declined();
  } else if (
    actionType === "intantBooking" ||
    actionType === "approved" ||
    actionType === "instantBooking"
  ) {
    return bookingConfirmed();
  } else if (actionType === "requestToBook") {
    return requestToBook();
  } else if (actionType === "expired") {
    return expired();
  } else if (
    actionType === "cancelledByHost" ||
    actionType === "cancelledByGuest"
  ) {
    return cancelled();
  } else if (actionType === "completed") {
    return completed();
  }
}


HostActions.propTypes = {
  actionType: PropTypes.string.isRequired,
  threadId: PropTypes.number.isRequired,
  reservationId: PropTypes.number,
  threadType: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  personCapacity: PropTypes.number.isRequired,
  guestDisplayName: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
};

export default withStyles(s, bt)(HostActions);
